import { render, staticRenderFns } from "./SubelementEditOptionsTab.vue?vue&type=template&id=f6143330"
import script from "./SubelementEditOptionsTab.vue?vue&type=script&lang=ts"
export * from "./SubelementEditOptionsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports